export const SESSION_INFO_COMMAND = 'session.info';

export type SessionInfoResponse = {
  cmd: {
    success: boolean;
    params: SessionInfoResult;
  };
};

export type ConnInfo = {
  protocol: string;
  remoteAddr: string;
};

export type OrgProfileSettings = {
  maxRetention: number;
  enCloudTriggers: boolean;
  enCampaigns: boolean;
  enCdpAccess: boolean;
  enEuicc: boolean;
  disableMgmtPortal: boolean;
  disableCustObjDefs: boolean;
};

export interface SessionInfoResult {
  allAgreementsSigned: boolean;
  allowSubOrgAccess?: any;
  connInfo: ConnInfo;
  hasOrgAdmin: boolean;
  hasSuperAdmin: boolean;
  hasSuperOps: boolean;
  id: string;
  initial: boolean;
  ipAddress: string;
  lastAccessed: Date;
  locale: string;
  mustResetPassword: boolean;
  orgId: string;
  orgKey: string;
  orgProfileSettings: OrgProfileSettings;
  ref: string;
  serverId: string;
  startTime: Date;
  ttl: number;
  userId: string;
  userName: string;
  whoAmI: string;
}
